import ProjectTeamSidebarWidgetModule from './sidebar-widget.module'

export default ProjectTeamSidebarWidgetModule
